export default __webpack_public_path__ + "static/media/0xd7ecf95cf7ef5256990beaf4ac895cd9e64cb947.fb1f3bf3.webp";